module.exports = __webpack_public_path__ + "static/media/contact2.8eda4f51.png";